import { render, staticRenderFns } from "./ReviseDict.vue?vue&type=template&id=1e18bf99&"
import script from "./ReviseDict.vue?vue&type=script&lang=js&"
export * from "./ReviseDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports